import { useMemo } from "react";
import { getMyPricingBriefColumns } from "../lib/getMyPricingBriefColumns";
import { useMyPricingBriefsList } from "../lib/hooks/useMyPricingBriefsList";
import { useMyPricingPoc } from "../lib/hooks/useMyPricingPoc";
import { useMyPricingUserIdParam } from "../lib/hooks/useMyPricingUserIdParam";
import styles from "./MyPricing.module.scss";
import { MyPricingBriefsSection } from "./MyPricingBriefsSection";
import { MyPricingPageHeader } from "./MyPricingPageHeader";
import { useNavigate } from "react-router-dom";

export function MyPricing() {
  const { userIdParam, setUserIdParam, isSuperUser } =
    useMyPricingUserIdParam();

  const {
    pricingWorkloadData,
    isPricingWorkloadLoading,
    selectedPoc,
    isPricingWorkloadPerUserLoading,
    pocSelectOptions,
    pocSelectValue,
    segmentOptions,
    getStatValue,
  } = useMyPricingPoc({ userIdParam, isSuperUser });

  const {
    segment,
    setSegment,
    pageNo,
    pageSize,
    searchQuery,
    setSearchQuery,
    briefs,
    isFetching,
    totaldata,
    activeUserId,
    handlePaginationChange,
  } = useMyPricingBriefsList({
    userIdParam,
    selectedPocUserId: selectedPoc?.userId,
  });

  const navigate = useNavigate();

  const columns = useMemo(
    () => getMyPricingBriefColumns(activeUserId, navigate),
    [activeUserId]
  );

  return (
    <div className={styles.myPricingContainer}>
      <MyPricingPageHeader
        isSuperUser={isSuperUser}
        pricingWorkloadData={pricingWorkloadData}
        isPricingWorkloadLoading={isPricingWorkloadLoading}
        pocSelectOptions={pocSelectOptions}
        pocSelectValue={pocSelectValue}
        onPocChange={setUserIdParam}
      />

      <MyPricingBriefsSection
        isLoading={isPricingWorkloadPerUserLoading}
        segment={segment}
        onSegmentChange={setSegment}
        segmentOptions={segmentOptions}
        getStatValue={getStatValue}
        columns={columns}
        briefs={briefs}
        isFetching={isFetching}
        pageNo={pageNo}
        pageSize={pageSize}
        totaldata={totaldata}
        onPaginationChange={handlePaginationChange}
        searchQuery={searchQuery}
        onSearchQueryChange={setSearchQuery}
      />
    </div>
  );
}
